import React from 'react';

const CommentsListItemBodyWraper = ({ children }) => (
  <div className="flex-auto t-pl1 t-pl2-ns">
    {children}
  </div>
);

export default CommentsListItemBodyWraper;
